<footer>
  <div class="container-fluid">
    <div class="row gy-xl-0 gy-2">
      <div class="col-xl-5 col-xxl-4 text-center text-xl-start">
        © {{ year }}
        <a href="https://www.cc-institute.org/" target="_blank"
          >Competency & Credentialing Institute</a
        >. <span class="d-block d-sm-inline">All rights reserved.</span>
      </div>
      <div class="col-xxl-4 col-xl-4 text-center">
        Powered by
        <a href="https://www.theopeneyes.com/" target="_blank"
          >OpenEyes Technologies Inc.</a
        >
        @if (version) {
                    | {{ version }}
                  }
      </div>
      <div class="col-xxl-4 col-xl-3">
        <div class="ft-links justify-content-center justify-content-xl-end">
          <a href="https://www.cc-institute.org/privacy-policy/" target="_blank"
            >Privacy</a
          >
          |
          <a href="https://www.cc-institute.org/privacy-policy/" target="_blank"
            >Terms</a
          >
          |
          <a href="https://www.cc-institute.org/contact/" target="_blank"
            >Contact</a
          >
        </div>
      </div>
    </div>
  </div>
</footer>
